import { useMemo } from 'react';
import _ from 'lodash';

import { useAccountUsageStore } from '@/modules/employer/components/SetupEmployer/FinancialDetails/BankInformation/AccountUsage/stores';
import useGetEmployer from '@/modules/employer/hooks/useGetEmployer.query';

import { useGetHiddenFields } from '../../hooks';

export const BLOCKS_VALIDATION_TEXT = {
  CONTACTS_AND_SECURITY: 'Contacts/Security',
  FINANCIAL_DETAILS: 'Financial Details',
  // STATUS: 'Status',
};

export default () => {
  const {isPayrollContributionSectionHidden, isIndividualContributionSectionHidden} = useGetHiddenFields();
  const { formattedData } = useGetEmployer();
  const { findUnselectedMethods } = useAccountUsageStore();
  const unselectedMethods = useMemo(() => findUnselectedMethods({
    administratorFeesMethod: formattedData?.overridableProperties?.externalAdministratorFeesAccountMethod,
    payrollContributionMethod: formattedData?.overridableProperties?.externalPayrollContributionsAccountMethod,
    fundingReplenishmentMethod: formattedData?.overridableProperties?.externalReplenishmentAccountMethod,
    balanceAdjustmentMethod: formattedData?.overridableProperties?.externalBalanceAdjustmentAccountMethod,
  }), [formattedData, findUnselectedMethods]);
  const errors = useMemo(() => {
    const currentErrors: string[] = [];
    if (!_.isEmpty(unselectedMethods) && (!isIndividualContributionSectionHidden && !isPayrollContributionSectionHidden)) {
      currentErrors.push(BLOCKS_VALIDATION_TEXT.FINANCIAL_DETAILS);
    }
    // if (_.isEmpty(banksList)) {
    //   currentErrors.push(BLOCKS_VALIDATION_TEXT.FINANCIAL_DETAILS);
    // }
    return currentErrors;
  }, [isIndividualContributionSectionHidden, isPayrollContributionSectionHidden, unselectedMethods]);
  return errors;
};
